<template>
  <div
    ref="wrapperRef"
    class="error-wrapper"
  >
    <slot />

    <div
      v-if="isError && errorMessage && !errorObject.$pending"
      ref="errMessRef"
      class="error-address"
      :class="{ 'error-address__textarea': isTextarea }"
    >
      <v-icon
        name="warning-circle"
        width="24"
        height="24"
        class="error-address__icon"
        stroke="#FFC300"
        color="#FFC300"
      />
      <span class="error-address__text">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';

 
defineProps({
  errorMessage: { type: String, default: '' },
  isError: { type: Boolean, default: false },
  isTextarea: { type: Boolean, default: false },
  errorObject: { type: Object, default: () => ({ $pending: false }) },
});

 
const emit = defineEmits(['hide-error']);

const errMessRef = ref(null);
const errMessHeight = ref(0);
const wrapperRef = ref(null);
let resizeObserver = null;

onMounted(async () => {
  await nextTick();
  if (errMessRef.value) {
    // Guard against ResizeObserver loop errors.
    let timeoutId = null;

    resizeObserver = new ResizeObserver((entries) => {
      // Cancel the previous timeout.
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Use setTimeout to prevent an infinite loop.
      timeoutId = setTimeout(() => {
        for (const entry of entries) {
          console.log('entry', entry);
          const newHeight = entry.borderBoxSize[0].blockSize;
          if (newHeight !== errMessHeight.value) {
            errMessHeight.value = newHeight;
          }
        }
      }, 100); // ~60fps
    });

    resizeObserver.observe(errMessRef.value);
  }

  // Add a click-outside handler for error-wrapper.
  document.addEventListener('click', handleClickOutside);
});

// Handle clicks outside error-wrapper.
const handleClickOutside = (event) => {
  if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
    // Emit an event to hide the error.
    emit('hide-error');
  }
};

onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
  // Remove the click handler.
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
.error-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.error-address {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: var(--color-white);
  border-radius: 8px 8px 8px 8px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
  position: absolute;
  top: calc(100% + 8px);
  left: 12px;
  right: 12px;
  z-index: 50;

  &__icon {
    flex-shrink: 0;
  }

  &__text {
    color: rgba(14, 14, 34, 0.8);
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 1.2;
    text-align: left;
  }

  &__textarea {
    position: absolute;
    bottom: 0;
  }
}
</style>
